import { useEffect, useState } from 'react';
import { searchTickers } from '../utils/tickerSearch';
import { useSuggestSymbols } from './useTradeStation';

export function normalizeSuggestedSymbols(apiResults = []) {
  return apiResults
    .map((r) => ({
      symbol: r.Symbol || r.Name || '',
      name: r.Description || r.Name || '',
      type: (r.AssetType || r.Category || 'stock').toLowerCase(),
    }))
    .filter((r) => r.symbol);
}

export function useTickerSearch(query, { limit = 20, debounceMs = 250, enabled = true } = {}) {
  const { suggestSymbols } = useSuggestSymbols();
  const [results, setResults] = useState([]);

  useEffect(() => {
    if (!enabled) {
      setResults([]);
      return undefined;
    }
    const q = String(query || '').trim();
    if (!q) {
      setResults([]);
      return undefined;
    }

    setResults(searchTickers(q, limit));
    let cancelled = false;
    const timer = setTimeout(async () => {
      try {
        const apiResults = await suggestSymbols(q);
        if (cancelled || !apiResults?.length) return;
        setResults(normalizeSuggestedSymbols(apiResults));
      } catch (_) {
        // Keep the static JSON results already shown.
      }
    }, debounceMs);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [debounceMs, enabled, limit, query, suggestSymbols]);

  return results;
}
